if (process.env.NODE_ENV === 'production') {
    // Mute console.log, console.debug, and console.info in production
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    // Optionally mute warnings too:
    // console.warn = () => {};
  }

  export {}; // <-- Add this line to make it a module